export default __webpack_public_path__ + "static/adrien-d2dc7f233501c66513e0ef35b8955b01.jpg";